import { isNil } from 'lodash'

/**
 * 会员认证状态
 */
export enum MemberApproveStatus {
  SUCCESS = 0,
  FAIL = 1,
  EXPIRED = 2
}

export const MemberApproveStatusMap: Record<
  MemberApproveStatus,
  {
    text: string
    color: string
  }
> = {
  [MemberApproveStatus.SUCCESS]: { text: '认证成功', color: 'green' },
  [MemberApproveStatus.FAIL]: { text: '认证失败', color: 'red' },
  [MemberApproveStatus.EXPIRED]: { text: '认证过期', color: 'orange' }
}

export const getMemberApproveStatusMap = (approveStatus?: string | number) => {
  if (isNil(approveStatus)) {
    return {
      text: '未认证',
      color: 'red'
    }
  }
  return MemberApproveStatusMap[approveStatus as MemberApproveStatus]
}
